import { APICallV3Post } from 'reactApp/api/APICall';

class PromocodeAPICall extends APICallV3Post {
    _method = 'promo/validate';
}

export { PromocodeAPICall };
